import React from 'react';
import {Box, Grid, List, ListItem, Typography} from '@deere/fuel-react';
import {withStyles} from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {toCapitalize} from "../shared/utils";
import {NO_COMMENTS} from "../shared/Constants";

const StyledRatingFeedback = withStyles({
    iconFilled: {
        color: '#666',
    }
})(Rating);

export const SummaryRatingDetails = ({classes,feedbackList,maxStars}) => {
    return <AccordionDetails className={classes.accordionDetails}>
        <List disablePadding component="nav"
              aria-label="supplier list"
              className={classes.root}>
            {feedbackList && feedbackList.map((item, index) => {
                    const name = `${toCapitalize(item.stakeholder.user.firstName)} ${toCapitalize(item.stakeholder.user.lastName)}`
                    const rolesArr = item.stakeholder.roles.map(item => item.description)
                    const unitsArr = item.stakeholder.units.map(item => item.description)
                    return (
                        <ListItem style={{borderBottom: '1px solid #ccc', padding: '.75rem'}} key={index}>
                            <Grid container alignItems="center">
                                {(item.feedback.notApplicable === false && item.feedback.declined === false && item.feedback.rating !== "") ?
                                    <Grid item xs={10}>
                                        {item.feedback.comment ?
                                            <Typography variant="label">
                                                {item.feedback.comment}
                                            </Typography> :
                                            <Typography color="tertiary">
                                                {NO_COMMENTS}
                                            </Typography>
                                        }
                                    </Grid> :
                                    <Grid item xs={10}>
                                    </Grid>
                                }
                                <Grid item xs={2}>
                                    {(item.feedback.notApplicable === false && item.feedback.declined === false && item.feedback.rating !== "") ?
                                        <Box display="flex" justifyContent="flex-end">
                                            <StyledRatingFeedback
                                                defaultValue={parseInt(item.feedback.rating)}
                                                emptyIcon={<StarBorderIcon fontSize="inherit"/>}
                                                readOnly={true}
                                                max={maxStars}
                                            />
                                            <Typography size="md" fontWeight="bold" component="p" display="inline">
                                                &nbsp; {item.feedback.rating}
                                            </Typography>
                                        </Box> :
                                        <Box display="flex" justifyContent="flex-end">
                                            {item.feedback.declined === true && (
                                                <Typography size="md" fontWeight="semibold">
                                                    Declined
                                                </Typography>
                                            )}
                                            {item.feedback.notApplicable === true && (
                                                <Typography size="md" fontWeight="semibold">
                                                    Not Applicable
                                                </Typography>
                                            )}
                                            {(item.feedback.notApplicable === false && item.feedback.declined === false && item.feedback.rating === "") && (
                                                <Typography size="md" color="tertiary">
                                                    No Response
                                                </Typography>
                                            )}
                                        </Box>
                                    }
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography color="tertiary" size="sm">
                                        {name} | {rolesArr.join(', ')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Box display="flex" justifyContent="flex-end">
                                        <Typography color="tertiary" size="sm">
                                            {unitsArr.join(', ')}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </ListItem>
                    )
                }
            )}
        </List>
    </AccordionDetails>
}